import { render } from "./TheDiemDuLich.vue?vue&type=template&id=4b81f8fe"
import script from "./TheDiemDuLich.vue?vue&type=script&lang=js"
export * from "./TheDiemDuLich.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__